import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { isUndefined } from 'util';
import { Layout, LayoutDetail } from '../../../../models/loyalty-layout.model';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { LayoutDetailService } from '../../../../services/loyalty/layout-detail.service';
import { LoyaltyLayoutService } from './../../../../services/loyalty/layout.service';
import _date = moment.unitOfTime._date;

@Component({
  selector: 'app-form-layout-loyalty',
  templateUrl: './form-layout-loyalty.component.html',
  styleUrls: ['./form-layout-loyalty.component.css']
})
export class FormLayoutLoyaltyComponent implements OnInit {

  selectedFlg_print: Array<string>;
  form: FormGroup;
  @Input() layoutId: string;
  @Input() editMode: boolean;
  layoutdetailsForm: Array<FormGroup>;

  public invalidSubmit: boolean;
  public validators = {
    integerNotNegative: KoncentroValidators.integerNotNegative
  };

  fields: any;
  fieldsLayout: any;

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private layoutService: LoyaltyLayoutService,
    private layoutDetailService: LayoutDetailService
  ) { }

  get details(): FormArray {
    return this.form.get('details') as FormArray;
  }

  ngOnInit() {
    this.selectedFlg_print = [];
    this.layoutdetailsForm = [];

    this.layoutId = this.activatedRoute.snapshot.params['layoutId'];
    this.editMode = (typeof this.layoutId !== 'undefined');

    let layout: Observable<Layout>;
    let layoutDetail: Observable<any>;

    if (!this.editMode) {
      layout = Observable.of(new Layout());
      layoutDetail = Observable.of(new LayoutDetail());
    }else {
      layout = this.layoutService.get(this.layoutId);
      layoutDetail = this.layoutDetailService.list(this.layoutId);
    }

    this.layoutService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.layoutDetailService.getFields().subscribe(res => {
      this.fieldsLayout = res;
    });

    Observable.zip(layout, layoutDetail).subscribe(([res, resLayoutService]) => {

      if ( !isUndefined(resLayoutService.data) ) {
        for (const service of resLayoutService.data) {
          this.layoutdetailsForm.push(this.fb.group(this.getLayoutDetail(service)));
        }
      }

      this.form = this.fb.group({
        description: res.description || '',
        details: this.fb.array(this.layoutdetailsForm)
      });

    });

  }

  save() {

    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    const layout = new Layout();
    layout.description = this.form.get('description').value;
    if (!this.editMode) {
      this.layoutService.create(layout).subscribe(res => {
        this.layoutId = res.id;
        this.addLayoutDetail(this.form.get('details').value);
      });
    }else {
      layout.id = this.layoutId;
      this.layoutService.update(layout).subscribe(res => {
        this.addLayoutDetail(this.form.get('details').value);
      });
    }
  }

  getLayoutDetail(layoutdetail: LayoutDetail) {
    return {
      id: layoutdetail.id || null,
      row_position: layoutdetail.row_position || '',
      row_description: layoutdetail.row_description || '',
      row_max_lenght: layoutdetail.row_max_lenght || '',
      start_offset: layoutdetail.start_offset || '',
      flg_print: layoutdetail.flg_print || false
    };
  }

  aggiungi() {
    this.details.push(this.fb.group(
      this.getLayoutDetail(new LayoutDetail())
    ));
  }

  deleteDetail(i: number, layoutDetail: FormGroup) {
    if (!layoutDetail.get('id').value) {
      this.details.removeAt(i);
      return;
    }
    this.layoutDetailService.remove(this.layoutId, layoutDetail.get('id').value).subscribe((res) => {
      this.details.removeAt(i);
    });
  }

  addLayoutDetail(layoutDetails: Array<LayoutDetail>) {
    if (layoutDetails.length > 0) {
      const requests = [];
      for (const detail of layoutDetails) {
        detail.flg_print = (detail.flg_print) ? 1 : 0;
        if ( !detail.id ) {
          delete detail.id;
          requests.push(this.layoutDetailService.create(this.layoutId, detail));
        } else {
          const idDetail = detail.id;
          delete  detail.id;
          requests.push(this.layoutDetailService.update(this.layoutId, idDetail, detail));
        }
      }
      Observable.zip(...requests).subscribe((resCreateDetails) => {
        this.router.navigate(['/loyalty/layout/']);
      });
    }else {
      this.router.navigate(['/loyalty/layout/']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-layout/form-layout-loyalty/form-layout-loyalty.component.ts